import _ from 'lodash'
import { UUID } from '@/plugins/common'

export default class DisplayFormat {
  constructor (args = {}) {
    const defaults = {
      id: UUID.create(),
      type: '',
      condition: '',
      value: ''
    }
    _.defaults(this, args, defaults)
  }
}



// WEBPACK FOOTER //
// ./src/store/report/displayFormat.js